import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './state/app.tsx';
import { LayoutProvider } from './state/layout.tsx';
import { ToastHost } from './components/Toast.tsx';
import { GuestPromptHost } from './components/GuestPrompt.tsx';
import { App } from './App.tsx';

/* 样式的加载顺序有讲究：
     theme.css  先来 —— 它定义全部 CSS 变量（颜色、间距、字号）
     ui.css     用那些变量画组件
     app.css    最后 —— 网页版自己加的那几块，要能覆盖前面的
   顺序反了会出现「变量还没定义就被用了」，表现是某些颜色变透明。 */
import './styles/theme.css';
import './styles/ui.css';
import './styles/app.css';

const el = document.getElementById('root');
if (!el) {
  /* index.html 里一定有 #root。真没有的话说明 HTML 被改坏了 ——
     此时静默失败会得到一个纯白页面，没有任何线索 */
  throw new Error('index.html 里找不到 #root');
}

createRoot(el).render(
  <StrictMode>
    <BrowserRouter>
      <AppProvider>
        <ToastHost>
          {/* 布局要知道「我是谁」（存进哪个账号）、出错要能弹提示，所以在这两层里面 */}
          <LayoutProvider>
            {/* 要在路由里面（它要跳去登录页）、在 AppProvider 里面（它要知道语言） */}
            <GuestPromptHost>
              <App />
            </GuestPromptHost>
          </LayoutProvider>
        </ToastHost>
      </AppProvider>
    </BrowserRouter>
  </StrictMode>
);
